import RouteError from "../base/route-error.js"
import PrivateRoute from "../base/private-route.js"
import { useContext, useMemo, lazy, Suspense } from "react"
import { AppContext } from "../base/app-context-provider.js"
import { featuresFlatMap } from "utils"
import { Loader } from "widgets"

const ManageAgency = lazy(() => import("./manage-agency.js"))
const AgencyDetails = lazy(() => import("./agency-details.js"))

export const useAgencyRoutes = () => {
  const appContext = useContext(AppContext)

  const features = useMemo(
    () => featuresFlatMap(appContext?.user?.featureDTOList)?.["agency"] ?? [],
    [appContext?.user?.featureDTOList],
  )

  const agencyRoutes = useMemo(
    () =>
      _.compact([
        {
          path: "agency",
          errorElement: <RouteError />,
          element: <PrivateRoute />,
          children: _.compact([
            features["search-agency"] && {
              path: "manage-agency",
              element: (
                <Suspense fallback={<Loader />}>
                  <ManageAgency />
                </Suspense>
              ),
            },
            features["view-agency"] && {
              path: "view-agency",
              element: (
                <Suspense fallback={<Loader />}>
                  <AgencyDetails
                    mode="view"
                    parentRoute="/agency/manage-agency"
                    title="View Agency"
                  />
                </Suspense>
              ),
            },
            features["view-agency"] && {
              path: "view-my-agency",
              element: (
                <Suspense fallback={<Loader />}>
                  <AgencyDetails
                    mode="view"
                    parentRoute="/"
                    title="View Agency"
                  />
                </Suspense>
              ),
            },
            features["modify-agency"] && {
              path: "update-agency",
              element: (
                <Suspense fallback={<Loader />}>
                  <AgencyDetails
                    mode="modify"
                    parentRoute="/agency/manage-agency"
                    title="Modify Agency"
                  />
                </Suspense>
              ),
            },
            features["map-supplier"] && {
              path: "map-supplier",
              element: (
                <Suspense fallback={<Loader />}>
                  <AgencyDetails
                    mode="map"
                    parentRoute="/agency/manage-agency"
                    title="Map Supplier"
                  />
                </Suspense>
              ),
            },
          ]),
        },
      ]),
    [features],
  )
  return agencyRoutes
}
